import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import moment from 'moment'

Vue.component(FeatherIcon.name, FeatherIcon)

Vue.filter('formatDate', value => moment(new Date(value)).format('D MMM YYYY HH:mm'))
